import { Component } from '@angular/core';

import { GoogleTagManagerService } from './_configs/google-tag-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {

  title = 'TenderShark';

  latitude: number | undefined;
  longitude: number | undefined;
  errorMessage: string | undefined;

  constructor(
    private gtmService: GoogleTagManagerService) { }

  ngOnInit() {
    this.gtmService.loadGTM();
  }
}